import { IslandComponent } from '@island-runtime/types';
import { useRescuePopupTriggers } from '@hooks/popups/useRescuePopupTriggers';

/**
 * `data-react-island="RescuePopup"` — renders nothing. The host includes it on
 * funnel pages only (edusson `react_rescue_popup.html.twig`), and there it
 * opens the rescue offer after the paywall closes (`useRescuePopupTriggers`);
 * a `?modal=rescue` link is opened by `usePopupAutoOpen`, which honours it only
 * where this island is mounted (`AUTO_OPEN_ISLANDS`). Being an island, it also
 * makes the island root (`island-runtime/IslandRoot.tsx`, which renders
 * `Popups` / `Toasts`) exist on a funnel page with no other island.
 *
 * It takes no `data-props`.
 */
const RescuePopupIsland: IslandComponent = () => {
  useRescuePopupTriggers();

  return null;
};

export default RescuePopupIsland;
